import React, { useEffect, useState } from 'react';
import { Mission } from '../../types/missions';
import { missionsService } from '../../services/missionsService';
import { Button, Table, Space, message } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '../../components/layout/PageLayout';

const AdminMissions: React.FC = () => {
  const [missions, setMissions] = useState<Mission[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadMissions();
  }, []);

  const loadMissions = async () => {
    try {
      const data = await missionsService.getMissions();
      setMissions(data);
    } catch (error) {
      message.error('Erreur lors du chargement des missions');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await missionsService.deleteMission(id);
      message.success('Mission supprimée avec succès');
      loadMissions();
    } catch (error) {
      message.error('Erreur lors de la suppression de la mission');
    }
  };

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Set',
      dataIndex: ['set', 'display_name'],
      key: 'set',
      render: (displayName: string, record: Mission) => (
        <span>{displayName || record.set.name}</span>
      ),
    },
    {
      title: 'Statut',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => (
        <span>{isActive ? 'Active' : 'Inactive'}</span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: Mission) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => navigate(`/admin/missions/${record.id}/edit`)}
          >
            Modifier
          </Button>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          >
            Supprimer
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <PageLayout disableAds={true}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-4">
            <Button
              onClick={() => navigate('/admin')}
              icon={<ArrowLeftOutlined />}
            >
              Retour
            </Button>
            <h1 className="text-2xl font-bold">Gestion des Missions</h1>
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/admin/missions/create')}
          >
            Nouvelle Mission
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={missions}
          loading={loading}
          rowKey="id"
        />
      </div>
    </PageLayout>
  );
};

export default AdminMissions; 